var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFragGranade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M46.1 47.3054L45.449 33.8429L50.6765 29.4029L47.453 26.0264L52.6145 20.9354V13.8659L55.655 12.4544L56.105 11.2604L58.5515 11.1524C58.5515 11.1524 58.6955 7.13541 63.1475 5.94141H67.925C67.925 5.94141 69.77 8.29341 72.05 9.34341V20.7989H70.0955V23.8784C70.0955 23.8784 73.2125 24.9719 75.1145 27.0419C77.0165 29.1119 78.7895 31.0469 78.7895 31.0469L82.4645 33.8444L81.8135 47.3069L76.4615 50.4944C76.4615 50.4944 69.653 56.0714 63.9575 55.7054C58.262 55.3409 52.8005 51.3614 52.8005 51.3614L46.1015 47.3054H46.1Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4716 36.0134H54.5011C53.5608 36.0134 52.7986 36.7757 52.7986 37.7159V45.8189C52.7986 46.7592 53.5608 47.5214 54.5011 47.5214H55.4716C56.4118 47.5214 57.1741 46.7592 57.1741 45.8189V37.7159C57.1741 36.7757 56.4118 36.0134 55.4716 36.0134Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4512 28.4294H60.7557V55.7039",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7981 41.7675H47.6501",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3222 41.7675H57.1737",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4392 47.5214H73.4097C74.3499 47.5214 75.1122 46.7592 75.1122 45.8189V37.7159C75.1122 36.7757 74.3499 36.0134 73.4097 36.0134H72.4392C71.4989 36.0134 70.7367 36.7757 70.7367 37.7159V45.8189C70.7367 46.7592 71.4989 47.5214 72.4392 47.5214Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4591 28.4294H67.1531V32.6474V55.7039",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1122 41.7675H80.2602",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5876 41.7675H70.7361",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7556 32.5934H67.1531",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7556 43.7759H67.1531",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7556 50.6699H67.1531",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8061 11.0054L66.6191 10.5704C66.6191 10.5704 64.3406 11.6564 64.3211 12.8144C64.3016 13.9724 68.8871 14.9864 71.8061 17.5199",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9554 55.704C73.0706 55.704 80.4599 48.3147 80.4599 39.1995C80.4599 30.0843 73.0706 22.695 63.9554 22.695C54.8402 22.695 47.4509 30.0843 47.4509 39.1995C47.4509 48.3147 54.8402 55.704 63.9554 55.704Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5496 23.6025V17.991H65.2081L70.0936 20.7975V23.877",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0938 20.7975H72.0483V9.34048C72.0483 9.34048 68.4648 7.34998 67.9233 5.93848H63.1458C63.1458 5.93848 58.5153 7.78348 58.5498 11.1495L56.1033 11.2575V17.9895H58.5498",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6529 12.453L52.6139 13.8645V20.934L47.4509 26.025L50.6744 29.4015",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0113 30.3675L45.4468 33.8415L46.0978 47.304C46.0978 47.304 51.9283 50.7075 52.7968 51.36",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8978 30.3675L82.4623 33.8415L81.8113 47.304C81.8113 47.304 75.9808 50.7075 75.1123 51.36",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFragGranade);
export default __webpack_public_path__ + "static/media/Frag Granade.6b7c8af1d413471ab853536a57409c63.svg";
export { ForwardRef as ReactComponent };